@if (form) {
  <div [formGroup]="form" class="form">
    <div class="flex flex-column gap-2 mb-3">
      <label class="font-semibold w-full" for="catalogItem">{{ fieldTitle }}*</label>
      <p-select
        name="catalogItem"
        formControlName="catalogItem"
        autoWidth="false"
        [options]="catalogItemOptions"
        optionLabel="label"
        [style]="{ width: '100%' }"
        [placeholder]="translate.instant('common.choose')"
        appendTo="body"
        [filter]="true"
        filterBy="label"
      />
    </div>

    <div class="flex justify-content-end gap-2 dialogBtnGroup">
      <app-button buttonText="common.cancel" (click)="closeDialog()"></app-button>
      <app-button buttonText="common.save" [disabled]="!form.valid" (click)="save()"></app-button>
    </div>
  </div>
}
